// authFetch.js
// Konum: src/authFetch.js
//
// Admin panelindeki (giriş gerektiren) tüm isteklerde bunu normal fetch yerine kullan.
// Firebase Auth'tan güncel ID token'ı alıp Authorization header'ına otomatik ekler.

import { auth } from './firebaseClient';

export async function authFetch(url, options = {}) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Giriş yapılmamış.');
  }

  const token = await user.getIdToken();

  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });
}
